// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const deleteAnnotations = async ({
    test,
    postId,
    deleteAnnotationIds,
}: {
    test: boolean,
    postId: string,
    deleteAnnotationIds: string[],
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleDeleteAnnotations = httpsCallable<
        Record<
            string,
            boolean | string | number | string[] | undefined
        >,
        boolean
    >(
        functions,
        'deleteAnnotations',
    );
    return handleDeleteAnnotations({
        test,
        postId,
        deleteAnnotationIds,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default deleteAnnotations;
